export default {
	name: "loadingTile",
};
